import revive_payload_client_4sVQNw7RlN from "/data/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/data/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/data/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _00_cookie_guard_client_iUrbxvzPjW from "/data/plugins/00.cookie-guard.client.ts";
import payload_client_yVLowv6hDl from "/data/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_J8PkxsSQmi from "/data/node_modules/nuxt-snackbar/dist/runtime/plugin.mjs";
import plugin_vue3_YdLad5Mpq3 from "/data/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/data/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/data/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/data/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/data/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/data/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/data/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_1UohGbtF8v from "/data/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import mitt_S0QU5gJPTl from "/data/plugins/mitt.ts";
import filters_znakZuvLqA from "/data/plugins/filters.js";
import i18n_sVHQBgnb3t from "/data/plugins/i18n.js";
import tawkMessenger_client_GnbJ52tFL3 from "/data/plugins/tawkMessenger.client.ts";
import v_calendar_client_hFB5p1S5zq from "/data/plugins/v-calendar.client.ts";
import veevalidate_components_HZdjzYOWQC from "/data/plugins/veevalidate-components.ts";
import veevalidate_rules_Xc2IpxFdQq from "/data/plugins/veevalidate-rules.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _00_cookie_guard_client_iUrbxvzPjW,
  payload_client_yVLowv6hDl,
  plugin_J8PkxsSQmi,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_1UohGbtF8v,
  mitt_S0QU5gJPTl,
  filters_znakZuvLqA,
  i18n_sVHQBgnb3t,
  tawkMessenger_client_GnbJ52tFL3,
  v_calendar_client_hFB5p1S5zq,
  veevalidate_components_HZdjzYOWQC,
  veevalidate_rules_Xc2IpxFdQq
]